import React, { useState } from "react";
import { Download, Share2 } from "lucide-react";
import { toast } from "sonner";
import { C, FONT, GLASS, glassInner } from "../kota/ui";
import { noKTW, golongan, namaKota } from "./KTW";
import { buatGambarKTW } from "./ktwGambar";

// Tombol kaca untuk halaman warga: utama (biru) / sekunder (kaca)
export const tombol = (utama = true) => ({ display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 6, height: 46, padding: "0 12px", borderRadius: 16, cursor: "pointer", fontSize: 13, fontWeight: 800, fontFamily: FONT, flex: "1 1 auto", whiteSpace: "nowrap",
  ...(utama ? { border: 0, background: C.blue, color: "#fff", boxShadow: "0 10px 24px rgba(0,0,205,.22)" } : { ...glassInner(true), color: GLASS.ink }) });

// Simpan KWJ (unduh PNG Story 1080x1920) + Bagikan (lembar bagikan HP dengan file gambar; fallback teks/salin)
export function TombolKTW({ w, lv, children }) {
  const [sibuk, setSibuk] = useState("");
  const gambar = async () => new File([await buatGambarKTW(w, lv)], `KWJ-${noKTW(w.id)}.png`, { type: "image/png" });
  const simpan = async () => {
    setSibuk("simpan");
    try { const f = await gambar(); const url = URL.createObjectURL(f); const a = Object.assign(document.createElement("a"), { href: url, download: f.name }); document.body.appendChild(a); a.click(); a.remove(); setTimeout(() => URL.revokeObjectURL(url), 4000); toast.success("KWJ tersimpan sebagai gambar Story"); }
    catch (e) { console.error("KWJ PNG:", e); toast.error("Gagal membuat gambar KWJ"); }
    setSibuk("");
  };
  const bagikan = async () => {
    setSibuk("bagikan");
    try {
      const f = await gambar();
      if (navigator.canShare?.({ files: [f] })) await navigator.share({ files: [f], title: "Kartu Warga Jawsel", text: `Aku warga resmi Kota ${namaKota(w.city_id)} · jawsel.fun` });
      else { const t = `Kartu Warga Jawsel · ${w.nama} (@${w.ig_username}) · ${noKTW(w.id)} · ${golongan(lv)} Lv ${lv} · jawsel.fun`; if (navigator.share) await navigator.share({ text: t }); else { await navigator.clipboard?.writeText(t); toast.success("Teks KWJ disalin — gambar bisa diunduh lewat Simpan KWJ"); } }
    } catch (e) { if (e?.name !== "AbortError") toast.error("Gagal membagikan KWJ"); }
    setSibuk("");
  };
  return (
    <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
      <button data-testid="kartu-simpan" onClick={simpan} disabled={!!sibuk} style={{ ...tombol(true), flex: "1 1 40%", opacity: sibuk ? .7 : 1 }}><Download size={15} /> {sibuk === "simpan" ? "Membuat…" : "Simpan KWJ"}</button>
      <button data-testid="kartu-bagikan" onClick={bagikan} disabled={!!sibuk} style={{ ...tombol(false), flex: "1 1 40%", opacity: sibuk ? .7 : 1 }}><Share2 size={15} /> {sibuk === "bagikan" ? "Membuat…" : "Bagikan"}</button>
      {children}
    </div>
  );
}
